import Grid from "@mui/material/Grid";
import _ from "lodash";
import React from "react";

import TaskField from "./taskField";

export default function GridTable(props) {
  function renderGridRow(table, rows, columns, uuid) {
    const linhas = [];
    for (let i = 0; i < rows; i++) {
      linhas.push(
        <Grid container key={`${uuid}-tr-${i}`} style={{ flexWrap: "nowrap" }}>
          {renderGridColumn(table, i, columns, uuid)}
        </Grid>,
      );
    }
    return linhas;
  }

  const previewStyle = {
    minHeight: 200,
    height: "100%",
    border: "1px solid #bfbfbf",
  };

  function renderGridColumn(table, currentLine, columns, uuid) {
    const colunas = [];
    for (let i = 0; i < columns; i++) {
      const currentColumn =
        props.fieldProperties &&
        props.fieldProperties.items &&
        props.fieldProperties.items[currentLine] &&
        props.fieldProperties.items[currentLine].items[i] &&
        props.fieldProperties.items[currentLine].items[i].items[0];
      colunas.push(
        <Grid
          item
          xs={Math.ceil(12 / columns)}
          key={`${uuid}tr-${currentLine}+td-${i}`}
          style={
            props.isPreview
              ? previewStyle
              : { padding: "1%", flexWrap: "nowrap" }
          }
          spacing={8}
        >
          {currentColumn && (
            <TaskField
              {...props}
              isPreview={props.isPreview}
              bpmForm={props.bpmForm}
              attributes={currentColumn}
              name={currentColumn.id}
              component={currentColumn.id}
              domNode={currentColumn}
              key={currentColumn.uuid}
              onChange={props.eventHandle}
              value={!props.isPreview && props.getValueHandle(currentColumn.id)}
              fieldProperties={currentColumn}
              error={!props.isPreview && props.getErrorHandle(currentColumn.id)}
              // { ...( readOnly && readOnly.value && { readOnly } ) }
              readOnly={!!props.readOnly}
              className={
                props.carga && props.carga.value ? "containerCarga" : ""
              }
              carga={props.carga && props.carga.value}
              //{...props}
            />
          )}
        </Grid>,
      );
    }
    return colunas;
  }

  const properties_columns =
    props.fieldProperties &&
    props.fieldProperties.properties &&
    props.fieldProperties.properties.find((i) => i.id === "columns");
  const properties_rows =
    props.fieldProperties &&
    props.fieldProperties.properties &&
    props.fieldProperties.properties.find((i) => i.id === "rows");

  //pega o valor default caso a propriedade 'rows' não seja encontrada
  let rows =
    props.attributes.properties &&
    props.attributes.properties.find((i) => i.id === "rows");
  rows = props.isPreview
    ? rows
      ? rows.value
      : props.attributes.rows
    : properties_rows
      ? properties_rows.value
      : props.fieldProperties.rows;

  //pega o valor default caso a propriedade 'columns' não seja encontrada
  let columns =
    props.attributes.properties &&
    props.attributes.properties.find((i) => i.id === "columns");
  columns = props.isPreview
    ? columns
      ? columns.value
      : props.attributes.columns
    : properties_columns
      ? properties_columns.value
      : props.fieldProperties.columns;

  const tableUuid = props.attributes.uuid || props.fieldProperties.uuid;
  const { style } = props;

  return (
    <Grid
      item
      xs={12}
      direction="row"
      //align="center"
      key={`${tableUuid}`}
      spacing={8}
      style={
        props.isPreview && _.isEmpty(style)
          ? {
              padding: "1%",
              textAlign: "center",
              backgroundColor: "#eeeeee",
            }
          : { ...style, padding: "1%" }
      }
    >
      {props.attributes &&
        renderGridRow(props.attributes, rows, columns, tableUuid)}
    </Grid>
  );
}
